import { doPost2, doGet2 } from "./common"

export const getGalleryItems = async payload => {

    const response = await doGet2(`/gallery/random`, payload)
    const data = await response.json()
    return data;
}



export const vote = async (breakId, stepId, galleryItemId) => {

    const payload = {
        breakId, 
        stepId, 
        videoUploadId: galleryItemId
    }

    const response = await doPost2(`/gallery/vote`, payload)
    const data = await response.json()
    return data;
}
